function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../../../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_supports-color@4.5.0__css-loader@0.28.11_lodash@4.1_0dba4eeb2dbfa95bd942c2dd5fdbdc4d/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-70826532\",\"scoped\":false,\"hasInlineConfig\":false}!less-loader!./style.less")
}
var normalizeComponent = require("!../../../../../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_supports-color@4.5.0__css-loader@0.28.11_lodash@4.1_0dba4eeb2dbfa95bd942c2dd5fdbdc4d/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!./script.js"
import __vue_script__ from "!!babel-loader!./script.js"/* template */
import __vue_template__ from "!!../../../../../../node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_supports-color@4.5.0__css-loader@0.28.11_lodash@4.1_0dba4eeb2dbfa95bd942c2dd5fdbdc4d/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-70826532\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!./template.html"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./resources/assets/front/js/components/vgb-modal/modal.vue
// module id = 198
// module chunks = 14